export class Quotation {
	constructor(
		public name: string,
	    public maker: string,
	    public maker_name:string,
	    public year: string,
	    public model: string,
	    public version: string,
	    public version_name: string,
			public sisa: string,
	    public email: string,
	    public cellphone: string,
	    public gender: number,
	    public zipcode: string,
	    public birth_date: string,
	    public referred_code: string,
	    public promo_code: string,
			public vehicle_type: string
	) { }
}
